// extracted by mini-css-extract-plugin
export default {"disabled":"style_disabled__hs2lR"};